import { render, staticRenderFns } from "./manageClassDialog.vue?vue&type=template&id=5db2c793&scoped=true&"
import script from "./manageClassDialog.vue?vue&type=script&lang=js&"
export * from "./manageClassDialog.vue?vue&type=script&lang=js&"
import style0 from "./manageClassDialog.vue?vue&type=style&index=0&id=5db2c793&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db2c793",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db2c793')) {
      api.createRecord('5db2c793', component.options)
    } else {
      api.reload('5db2c793', component.options)
    }
    module.hot.accept("./manageClassDialog.vue?vue&type=template&id=5db2c793&scoped=true&", function () {
      api.rerender('5db2c793', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/components/manageClassDialog.vue"
export default component.exports